import React from 'react';
import Sidebar from './Sidebar';
import { useRef } from "react";
import Hero from './Hero';
import About from './About';
import Projects from './Projects';
import Skills from './Skills';
import Contact from './Contact';
import Blog from '../Blog';

const Home = () => {
    const home = useRef(null);
    const about = useRef(null);
    const project = useRef(null);
    const skill = useRef(null);
    const blog = useRef(null);
    const contact = useRef(null);



    const scrollToSection = (elementRef) => {
        window.scrollTo({
            top: elementRef.current.offsetTop,
            behavior: "smooth",
        });
    };
    return (
        <div data-theme="cupcake" className=' lg:w-[1430px] mx-auto mt-2 mb-2 grid grid-cols-1' >

            <div>
                <div ref={home}>
                    <Hero></Hero>
                </div>
                <div ref={about}>
                    <About></About>
                </div>
                <div ref={project}>
                    <Projects></Projects>
                </div>
                <div ref={skill}>
                    <Skills></Skills>
                </div>
                <div ref={blog}>
                    <Blog></Blog>
                </div>
                <div ref={contact}>
                    <Contact></Contact>
                </div>

            </div>
            <div className='fixed'>
                <Sidebar scrollToSection={scrollToSection}
                    home={home}
                    about={about}
                    project={project}
                    skill={skill}
                    blog={blog}
                    contact={contact}
                ></Sidebar>
            </div>

        </div>
    )
};

export default Home;